const generateEmailHtml = (content) => `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Newsletter</title>
    <style>
        body {
            font-family: 'Open Sans', Arial, sans-serif;
            background-color: #f9f9f9;
            margin: 0;
            padding: 0;
        }
        .newsletterContainer {
            width: 100%;
            max-width: 600px;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            overflow: hidden;
        }
        .newsletterHeader {
            background-color: #F9F9F9;
            padding: 10px 0;
        }
        .newsletterContent {
            padding: 20px;
        }
        .newsletterHighlight {
            font-weight: 700;
            color: #007bff;
        }
        p {
            font-size: 14px;
            color: #555555;
            line-height: 1.6;
            margin-bottom: 20px;
        }
        h1 {
            font-size: 28px;
            color: #333333;
            margin-bottom: 20px;
            text-align: center;
        }
        .newsletterFooter {
            background-color: #F9F9F9;
            padding: 10px;
            text-align: center;
            font-size: 10px;
            color: #555555;
        }
        .newsletterFooter a {
            color: #007bff;
            text-decoration: none;
        }
        .newsletterFooter a:hover {
            text-decoration: underline;
        }
        .newsletterLogo,
        .newsletterSecondaryLogo {
            display: inline-block;
            vertical-align: middle;
        }
        .newsletterLogo {
            max-width: 150px;
        }
        .newsletterSecondaryLogo {
            max-width: 175px;
        }
        .separator {
            border-top: 1px solid #dddddd;
            margin: 20px 0;
        }

        ul {
            padding-left: 20px;
            margin-bottom: 20px;
        }
        
        li {
            font-size: 14px;
            color: #555555;
            line-height: 1.6;
            margin-bottom: 10px;
        }
        

        .button {
            display: block;
            width: 100%;
            padding: 10px 20px;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            background-color: #45A048;
            border-radius: 5px;
            text-align: center;
            text-decoration: none;
            margin-top: 10px;
            box-sizing: border-box;
        }
        .button:hover {
            background-color: #A6DAAD;
        }
        .button:visited {
            color: #ffffff;
            background-color: #6A948B;
        }
        

      
        @media only screen and (max-width: 600px) {
            .newsletterHeader {
                text-align: center;
            }
            .newsletterLogo,
            .newsletterSecondaryLogo {
                display: block;
                margin: 0 auto;
                max-width: 120px;
            }
            .newsletterSecondaryLogo {
                max-width: 140px;
            }
            .newsletterContent img {
                max-width: 100%;
                height: auto;
            }
        }
    </style>
</head>
<body>
    <div class="newsletterContainer">
        <div class="newsletterHeader">
            <table width="100%">
                <tr>
                    <td align="left" style="width: 33%;">
                        <img src="https://share1.cloudhq-mkt3.net/8fb9396849931a.png" alt="Polderzicht Logo" class="newsletterLogo">
                    </td>
                    <td align="center" style="width: 34%;">
                        <img src="https://share1.cloudhq-mkt3.net/2be83a200f8536.png" alt="Secondary Logo" class="newsletterSecondaryLogo">
                    </td>
                    <td style="width: 33%;"></td>
                </tr>
            </table>
        </div>
        <div class="newsletterContent">
            ${content}
        </div>
        <div class="newsletterFooter">
            <p>Wilt u e-mails van de VVE op een ander e-mailadres ontvangen? Of wilt u helemaal geen e-mail van de VVE Polderzicht ontvangen? Stuur dan een mail naar <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
            <p>VvE Prof. vd Scheerstraat 195-305 | Brievenbus: 209 | 2035AM Haarlem</p>
            <p>Website: <a href="https://www.vvepolderzicht.nl/" target="_blank">www.vvepolderzicht.nl</a> | E-mail: <a href="mailto:bestuurpolderzicht@gmail.com">bestuurpolderzicht@gmail.com</a></p>
            <p>KvK 51159392 | NL 44 ABNA 0528 485 547</p>
        </div>
    </div>
</body>
</html>
`;

export default generateEmailHtml;